import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function showError(initiator, ...args) {
    CABLES.logErrorConsole('[' + initiator + ']', ...args)
}

function resizeCanvasToContainer(canvas, container) {
    canvas.width = container.clientWidth
    canvas.height = container.clientHeight
}

// Fade the canvas in (opacity-0 + transition classes in the template) once the patch has loaded.
// The timeout is a fallback so the canvas never stays invisible if loading never reports finished.
function revealCanvas(canvas) {
    const reveal = () => canvas.classList.remove('opacity-0')
    setTimeout(reveal, 5000)
    return reveal
}

let patch1 = null
let patch2 = null

var cablesScript = document.querySelector('script[src*="cables.js"]')
var base = cablesScript.src.replace(/js\/cables\.js.*$/, '')
// Same ?v= as the cables scripts in base.twig, so the patch JSON is cache-busted too
var version = new URL(cablesScript.src).search

document.addEventListener('CABLES.jsLoaded', function (event) {
    var canvas1 = document.getElementById('glcanvas1')
    var container1 = document.getElementById('container1')
    var canvas2 = document.getElementById('glcanvas2')
    var container2 = document.getElementById('container2')

    // Size canvases to their containers before patch init
    // resizeCanvasToContainer(canvas1, container1)
    // resizeCanvasToContainer(canvas2, container2)
    if (canvas1) {
        patch1 = new CABLES.Patch({
            patchFile: base + 'js/Birrd_Web_v.0.4b.json' + version,
            prefixAssetPath: base,
            assetPath: base + 'assets/',
            jsPath: 'js/',
            glCanvasId: 'glcanvas1',
            glCanvasResizeToWindow: true,
            onError: showError,
            onFinishedLoading: revealCanvas(canvas1),
            canvas: { alpha: true, premultipliedAlpha: true },
            variables: {
                options: {
                    darkTheme: true
                }
            }
        })

        canvas1.addEventListener(
            'touchmove',
            function (e) {
                e.preventDefault()
            },
            false
        )

        let passed = false
        const st = ScrollTrigger.create({
            trigger: '.js-home-canvas',
            // markers: true,
            start: 'top top',
            end: () => ScrollTrigger.maxScroll(window),

            onUpdate: (self) => {
                const over100vh = self.scroll() >= window.innerHeight

                if (over100vh && !passed) {
                    passed = true
                    console.log('[header patch] pause: header uit beeld')
                    // 👉 actie bij voorbij 100vh naar beneden

                    patch1.pause()
                }

                if (!over100vh && passed) {
                    passed = false
                    console.log('[header patch] resume: header in beeld')
                    // 👉 actie bij terug omhoog

                    patch1.resume()
                }
            }
        })
    }

    console.log(base)
    if (canvas2) {
        patch2 = new CABLES.Patch({
            patchFile: base + 'js/Birrd_Web_v.0.4b.json' + version,
            prefixAssetPath: base,
            assetPath: base + 'assets/',
            jsPath: 'js/',
            glCanvasId: 'glcanvas2',
            glCanvasResizeToWindow: true,
            onError: showError,
            onFinishedLoading: revealCanvas(canvas2),
            canvas: { alpha: true, premultipliedAlpha: true },
            variables: {
                options: {
                    darkTheme: false
                }
            }
        })

        canvas2.addEventListener(
            'touchmove',
            function (e) {
                e.preventDefault()
            },
            false
        )

        const main = document.getElementById('main')
        let patch2Visible = null
        let patch2VisibilityRaf = null
        const footerVisibilityMargin = 24

        const setPatch2Visible = (visible) => {
            if (patch2Visible === visible) return

            patch2Visible = visible

            if (visible) {
                console.log('[footer patch] resume: footer in beeld')
                patch2.resume()
            } else {
                console.log('[footer patch] pause: footer uit beeld')
                patch2.pause()
            }
        }

        const updatePatch2Visibility = () => {
            patch2VisibilityRaf = null

            if (!main) {
                setPatch2Visible(true)
                return
            }

            const revealStart =
                main.getBoundingClientRect().bottom +
                window.scrollY -
                window.innerHeight

            if (patch2Visible === true) {
                setPatch2Visible(
                    window.scrollY >= revealStart - footerVisibilityMargin
                )
            } else {
                setPatch2Visible(
                    window.scrollY >= revealStart + footerVisibilityMargin
                )
            }
        }

        const requestPatch2VisibilityUpdate = () => {
            if (patch2VisibilityRaf) return

            patch2VisibilityRaf = requestAnimationFrame(updatePatch2Visibility)
        }

        window.addEventListener('scroll', requestPatch2VisibilityUpdate, {
            passive: true
        })
        window.addEventListener('resize', requestPatch2VisibilityUpdate)
        ScrollTrigger.addEventListener('refresh', requestPatch2VisibilityUpdate)
        requestPatch2VisibilityUpdate()
    }

    // // Resize each canvas when its container changes size
    // var ro1 = new ResizeObserver(function () {
    //     resizeCanvasToContainer(canvas1, container1)
    //     if (patch1 && patch1.gl) patch1.gl.canvas.width = canvas1.width
    // })
    // ro1.observe(container1)

    // var ro2 = new ResizeObserver(function () {
    //     resizeCanvasToContainer(canvas2, container2)
    //     if (patch2 && patch2.gl) patch2.gl.canvas.width = canvas2.width
    // })
    // ro2.observe(container2)

    // // Pause/resume patches when they enter/leave the observer frame
    // // rootMargin mirrors the frame: 25% inset top/bottom, 10% inset left/right
    // var ioOptions = { rootMargin: '-37.5% -10% -37.5% -10%', threshold: 0 }

    // function makePauseObserver(patch) {
    //     return new IntersectionObserver(function (entries) {
    //         entries.forEach(function (entry) {
    //             if (entry.isIntersecting) {
    //                 patch.resume()
    //             } else {
    //                 patch.pause()
    //             }
    //         })
    //     }, ioOptions)
    // }

    // makePauseObserver(patch1).observe(container1)
    // makePauseObserver(patch2).observe(container2)
})

export const resumeCanvas1 = () => {
    if (canvas1) {
        canvas1.resume()
    }
}

export const pauseCanvas1 = () => {
    if (canvas1) {
        canvas1.pause()
    }
}
